import type { AdminRole } from '@/lib/api-admin';

/**
 * 무통장 입금 계좌 마스터 관리 RBAC. (be-order 동결 계약 — order-service
 * `@PreAuthorize` 가 SUPER_ADMIN / OPS_ADMIN 만 허용한다고 가정.)
 * orderPolicy / shippingFee / orderFormFields 와 동일한 운영 권한 게이트.
 * read·write 동일 게이트(설정 페이지 전체가 운영 권한). 권위는 BE 가 최종 판정.
 */
export const BANK_ACCOUNT_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
];
